import React  from 'react';
import DestSelector from './DestSelector';
import FileEditor from './FileEditor';
import DemoSelect from './DemoSelect';



class Form extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			config: "",
			input: ""
		};
		this.buildFormData = this.buildFormData.bind(this);

		this.handleChange = this.handleChange.bind(this);
		this.handleConfig = this.handleConfig.bind(this);
		this.handleInput = this.handleInput.bind(this);

		this.handleSubmit = this.handleSubmit.bind(this);
		this.autoSubmit = this.autoSubmit.bind(this);


	}
	buildFormData() {
		return {
			...this.state,
			dest: this.props.dest
		}
	}
	componentDidUpdate(props) {
		if(this.props.dest !== props.dest) {
			this.autoSubmit();
		}
	}
	handleChange(field, newValue, submit) {
		const newState = {
			[field]: newValue
		};
		if(submit) {
			this.setState(newState, this.autoSubmit);
		} else {
			this.setState(newState);
		}
		//Reset la destination à sa previous pour forcer le re-render
		this.props.handleDest(this.props.dest);
	}
	handleConfig(newValue, submit) {
		this.handleChange("config", newValue, submit);
	}
	handleInput(newValue, submit) {
		this.handleChange("input", newValue, submit);
	}
	handleSubmit(event) {
		event.preventDefault();
		this.props.handleSubmit(this.buildFormData());
	}
	autoSubmit() {
		if(this.state.config && this.state.input && this.props.dest) {
			this.props.handleSubmit(this.buildFormData());
		}
	}
	render() {
		return (
			<form id={this.props.formId} onSubmit={this.handleSubmit}>
				<DemoSelect handleConfig={this.handleConfig} handleInput={this.handleInput} autoSubmit={this.autoSubmit}/>
				<FileEditor name="Configuration" value={this.state.config} handleEdit={this.handleConfig} accept=".yaml,.yml"/>
				<FileEditor name="StepXML" value={this.state.input} handleEdit={this.handleInput} accept=".xml"/>
				<DestSelector value={this.props.dest} destinations={this.props.destinations} handleChange={this.props.handleDest}/>
			</form>
		);
	}
}

export default Form;